import { render } from "./templateHeader.vue?vue&type=template&id=31c013ff&scoped=true"
import script from "./templateHeader.vue?vue&type=script&lang=js"
export * from "./templateHeader.vue?vue&type=script&lang=js"

import "./templateHeader.vue?vue&type=style&index=0&id=31c013ff&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c013ff"]])

export default __exports__